import React from 'react'
import axios from 'axios'
import {WKPreload, WKInfiniteScroll} from '../../components/wk'
import {WKBottomNav, WKLoadMore} from '../../components/wk'
import IntroArea from './IntroArea'
import TabBar from './TabBar'
import ListenListItem from './ListenListItem'
import MyLectureItem from './MyLectureItem'
import BoughtPage from '../BoughtPage/BoughtPage'
import {NoneItem} from '../../components/details'

import '../../css/page/MyNewWeiKePage.css'
import FloatCoupon from '../../components/activity/FloatCouponSpecial/FloatCoupon'


class MyNewWeiKePage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tab: 1, // 1: 最近学习; 2: 最近讲课
            initialized: false,
            loadingListenMore: false,
            loadingMyMore: false
        }
        this.setTab = this.setTab.bind(this)
    }

    setTab(tab) {
        document.documentElement.scrollTop = document.body.scrollTop = 0
        sessionStorage.setItem('my-wk-tab', tab)
        this.setState({tab})
    }

    componentDidMount() {
        document.title = '我的微课'
        let tab = sessionStorage.getItem('my-wk-tab') || 1
        this.setState({tab: +tab})
        this.fetchListenData()
        this.fetchMyLectures()
    }

    componentWillUnmount() {
        this.setState({initialized: false})
    }

    fetchListenData() {
        this.setState({loadingListenMore: true}, () => {
            axios.get('/api/history/classroom_v1', {
                params: {
                    offset: this.state.listenData ? this.state.listenData.next_offset : 0,
                    limit: this.state.listenData ? 10 : 3
                }
            }).then(res => {
                let data = res.data
                if (data.code === 0) {
                    if (!this.state.listenData) {
                        this.setState({listenData: data.data, initialized: true, loadingListenMore: false}, () => {
                            setTimeout(() => {
                                window.scrollTo({
                                    top: 0,
                                    behavior: 'smooth'
                                })
                            }, 500)
                        })
                    } else {
                        let {has_more, lectures, next_offset} = data.data
                        lectures = this.state.listenData.lectures.concat(lectures)
                        this.setState({listenData: {has_more, lectures, next_offset}, loadingListenMore: false})
                    }
                }
            })
        })
    }

    fetchMyLectures() {
        this.setState({loadingMyMore: true}, () => {
            axios.get('/api/history/lecturer_record_v1', {
                params: {
                    offset: this.state.myLecturesData ? this.state.myLecturesData.next_offset : 0,
                    limit: 10
                }
            }).then(res => {
                let data = res.data
                if (data.code === 0) {
                    if (!this.state.myLecturesData) {
                        this.setState({myLecturesData: data.data, initialized: true, loadingMyMore: false})
                    } else {
                        let {has_more, lectures, next_offset} = data.data
                        lectures = this.state.myLecturesData.lectures.concat(lectures)
                        this.setState({myLecturesData: {has_more, lectures, next_offset}, loadingMyMore: false})
                    }
                }
            })
        })
    }

    render() {
        const {tab, initialized, listenData, myLecturesData} = this.state
        let loadingStatus = null
        if (listenData) {
            loadingStatus = {
                ended: !listenData.has_more,
                loading: this.state.loadingListenMore,
                has_more: listenData.has_more,
                loadMethod: () => {
                    this.fetchListenData()
                }
            }
        }

        if (!initialized) {
            return <div className="wk-page">
                <WKPreload/>
            </div>
        }

        return (
            <div className='my-new-weike-page mywkpage wk-page'>
                <TabBar tab={tab} clickHandle={this.setTab}/>

                <div className="weike-tab-body">
                    {tab === 1 &&
                    <div style={{marginBottom: '84px'}}>
                        <div style={{backgroundColor: '#F8F8F8'}}>
                            <div className="weike-listen-list">
                                {listenData &&
                                (listenData.lectures.length > 0 ?
                                        listenData.lectures.map((item, index) => <ListenListItem type={item.channel ? "channel" : "lecture"} key={index} data={item} itemIndex={index}/>)
                                        :
                                        <div className="mywk_noitem">
                                            <NoneItem
                                                img="https://static-1253442168.image.myqcloud.com/picture/5915685_83a6201fde722ab5078f24fe171ed444.jpg"
                                                text="还没有学习记录"
                                                btnText="去学习"
                                                btnType="primary"
                                                btnMethod={() => window.location = "/"}
                                                isFixed={false}
                                            />
                                        </div>
                                )}
                            </div>

                            {listenData && listenData.has_more &&
                            <div style={{padding: '0 10px 10px'}}>
                                <WKLoadMore loadingstatus={loadingStatus}/>
                            </div>
                            }
                        </div>

                        <IntroArea tabIndex={0}/>
                    </div>
                    }

                    {tab === 2 &&
                    <div style={{marginTop: '10px', marginBottom: '100px'}}>
                        <div className="weike-my-lectures">
                            {myLecturesData &&
                            (myLecturesData.lectures.length > 0 ?
                                    myLecturesData.lectures.map((item, index) => <MyLectureItem key={index} data={item}/>)
                                    :
                                    <NoneItem
                                        img="https://static-1253442168.image.myqcloud.com/picture/5915685_ac3c913105ee0e44e8718283f15a0047.jpg"
                                        text="传道授业，从第一堂课开启"
                                        btnText="去讲课"
                                        btnType="primary"
                                        btnMethod={() => window.location = "/liveroom/create/guide"}
                                        isFixed={true}
                                    />
                            )}
                        </div>
                        {myLecturesData && myLecturesData.lectures.length > 0 &&
                        <WKInfiniteScroll
                            onTouchBottom={() => this.fetchMyLectures()}
                            isStop={this.state.loadingMyMore}
                            distance={100}
                            isKill={!this.state.myLecturesData.has_more}
                            isShowLoading={true}
                        />
                        }
                    </div>
                    }

                    {tab === 3 &&
                      <div>
                          <BoughtPage/>
                      </div>
                    }
                </div>
                <FloatCoupon/>
                <WKBottomNav/>
            </div>
        )
    }
}

export default MyNewWeiKePage


// WEBPACK FOOTER //
// ./src/pages/mywkPage/MyNewWeiKePage.js